import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: var(--spacing-03) var(--spacing-07);
  display: flex;
  align-items: center;
  background: var(--private-02);
  align-self: flex-start;
`;

export const Icon = styled.div`
  display: flex;
  margin-right: var(--spacing-03);
`;

export const Label = styled.p`
  margin-bottom: 0;
`;
